export default __webpack_public_path__ + "static/media/dove_w.e046b50d.svg";